exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".order-groups .order-header{display:-webkit-box;display:-ms-flexbox;display:flex;-ms-flex-wrap:nowrap;flex-wrap:nowrap;margin:10px 0}.order-groups .order-header span{-webkit-box-flex:1;-ms-flex:1;flex:1;font-size:14px;color:#5e6d82;letter-spacing:0;line-height:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?minimize!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-134b7cfa","scoped":false,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Profiler/Common/OrderGroup.vue
// module id = 343
// module chunks = 0